import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { buildReturnPath } from '../utils/authRedirect';

/** Add to bag — redirects guests to login/register, then resumes on return. */
export function useAddToCart() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = useAuth();
  const { addItem } = useCart();

  const redirectToLogin = (pendingCart) => {
    navigate('/account', {
      state: {
        notice: 'Please log in to add items to your bag.',
        from: buildReturnPath(location),
        pendingCart,
      },
    });
  };

  return async (product, size = '', quantity = 1) => {
    const productId = product?._id || product;

    if (!isLoggedIn) {
      redirectToLogin({ productId, size, quantity: quantity || 1 });
      return false;
    }
    try {
      await addItem(product, size, quantity);
      return true;
    } catch (err) {
      if (err?.code === 'AUTH_REQUIRED') {
        redirectToLogin({ productId, size, quantity: quantity || 1 });
        return false;
      }
      throw err;
    }
  };
}
